<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-6">
        <b-card title="Останні події"></b-card>
      </div>
      <div class="col-12 col-md-6">
        <b-card title="Останні події"></b-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
